// Props:
//  resizeTrigger: flip when containing window has been resized, request a map redraw
//
//
// mapConfig = {
//   latN:
//   latS:
//   lngW:
//   lngE:
//   label: Text to display in attribution control
// }

// mapCenter = [latitude, longitude]

// polygons = [polygon]

// markersPending: set to false right after markersArrayRef refreshes, triggers a display refresh
//
// markersArrayRef = {
//   current: {
//     id: PxUid,
//     type: icon type,
//     code: icon code name,
//     anchor: relative anchor location { x: 0 to 1, y: 0 to 1}
//     angle: optional, marker tilt in degrees
//     opacity: optional
//     sizePx: max. marker display width/height
//     lat:
//     lng:
//   }
// }
//
// mapEvent: callback function, can send:
//
// {event: 'clickMap'}
// {event: 'click', type: marker.type, code: marker.code,
//    id: marker.id, coordinates: containerPoint}
// {event: 'hover', type: marker.type, code: marker.code,
//    id: marker.id, coordinates: containerPoint}
// {event: 'leave', type: marker.type, code: marker.code, id: marker.id}
// {event: 'updateBounds', newBounds}
//
// Where newBounds = [[SWlat, SWlng], [NElat, NElng]]
// and containerPoint = [windowXPixels, windowYPixels]

import L from 'leaflet';
import PropTypes from 'prop-types';
import {
  useEffect,
} from 'react';

import { useLeafletMap } from '../leaflet';

function PxMapControls(props) {
  const {
    position = 'bottomleft',
    customButtons = [],
  } = props;

  const map = useLeafletMap();

  useEffect(
    () => {
    // Create the Custom Zoom Control as before
      const CustomZoom = L.Control.extend({
        onAdd() {
          const container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');

          const zoomInButton = L.DomUtil.create('a', 'leaflet-control-zoom-in', container);
          zoomInButton.innerHTML = '+';
          zoomInButton.href = '#';
          zoomInButton.title = 'Zoom in';
          L.DomEvent.on(zoomInButton, 'click', L.DomEvent.stopPropagation)
            .on(zoomInButton, 'click', L.DomEvent.preventDefault)
            .on(zoomInButton, 'click', () => map.zoomIn());

          const zoomOutButton = L.DomUtil.create('a', 'leaflet-control-zoom-out', container);
          zoomOutButton.innerHTML = '-';
          zoomOutButton.href = '#';
          zoomOutButton.title = 'Zoom out';
          L.DomEvent.on(zoomOutButton, 'click', L.DomEvent.stopPropagation)
            .on(zoomOutButton, 'click', L.DomEvent.preventDefault)
            .on(zoomOutButton, 'click', () => map.zoomOut());

          customButtons.forEach((thisButton) => {
            const { onClick, imgSrc } = thisButton;

            const customButton = L.DomUtil.create('a', 'custom-button-class', container);
            customButton.innerHTML = `<div style="padding: 4px;"><img src=${imgSrc} alt="Custom Action" /></div>`;
            customButton.href = '#';
            customButton.title = 'Custom Action';
            L.DomEvent.on(customButton, 'click', L.DomEvent.stopPropagation)
              .on(customButton, 'click', L.DomEvent.preventDefault)
              .on(customButton, 'click', onClick);
          });

          return container;
        },
      });

      const customZoomControl = new CustomZoom({ position }).addTo(map);

      return () => {
        customZoomControl.remove();
      };
    },
    [map, position, customButtons],
  );

  return null;
}

PxMapControls.propTypes = {
  position: PropTypes.string,
  customButtons: PropTypes.arrayOf(PropTypes.shape({
    imgSrc: PropTypes.string.isRequired,
    onClick: PropTypes.func,
  })),
};

export default PxMapControls;
